export enum AssociatedBrand {
  SCB = 1,
  Utility = 2,
}
